import { risapi, getAxiosConfig, handleApiError, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getVenues = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/venues', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};

export const fetchVenue = async (venueId, callback) => {
    try {
        const response = await risapi.get(`/api/venues/${venueId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};

export const createVenue = async (newVenue, callback) => {
    try {
        const formData = convertJsonToFormData(newVenue);
        const response = await risapi.post('/api/venues', formData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};

export const updateVenue = async (editVenue, callback) => {
    try {
        const formData = convertJsonToFormData(editVenue);
        formData.append('_method', 'put');
        const response = await risapi.post(`/api/venues/${editVenue.id}`, formData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};

export const destroyVenue = async (venue, callback) => {
    try {
        const response = await risapi.delete(`/api/venues/${venue.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ venue: venue }); // Success
        }
    } catch (error) {
        callback(error);
    }
};
